import { render, staticRenderFns } from "./bestAustraliaEdit.vue?vue&type=template&id=e3c46a04&"
import script from "./bestAustraliaEdit.vue?vue&type=script&lang=js&"
export * from "./bestAustraliaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports